import VuexORM from '@vuex-orm/core'
import VuexORMAxios from '@vuex-orm/plugin-axios'
import Laravel from '@/services/Laravel'
import AllModels from '@/models'
import ModelMethods from '@/models/model-methods'

VuexORM.use(VuexORMAxios, { axios: Laravel })

// Create a new instance of Database.
const database = new VuexORM.Database()

// Register Models to Database.
Object.values(AllModels).forEach((Model) => {
  ModelMethods(Model)
  return database.register(Model)
})

export default () => {
  return VuexORM.install(database)
}
